import React from "react";
import { motion } from "framer-motion";
import classes from "./PrivacyPolicy.module.css";
import BackgroundWatchlist from "../Components/BackgroundWatchlist";
import { Link, useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <motion.div className={classes.modal}>
      <BackgroundWatchlist>
        <div className={classes.navbar}>
          <button
            className={classes.close_btn}
            type="button"
            onClick={() => navigate("/home")}
          >
            <i className={`pi pi-arrow-left ${classes.close_icon}`} />
          </button>
        </div>

        <div className={classes.info_container}>
          <p className={classes.info}>Privacy Policy</p>
          <p className={classes.info_brief}>Last Updated: 01-August-2025</p>
        </div>
      </BackgroundWatchlist>

      <div className={classes.privacy_content}>
        <section className={classes.section}>
          <p className={classes.p}>
            This Privacy Policy describes how we collect, use, and protect your personal
            information when you use our entertainment website that provides
            details about movies and series, ratings, reviews, trailers, short
            clips, and includes a community feature where users can interact and
            share posts.
          </p>
          <p className={classes.p}>
            By accessing or using this website or app, you agree to the terms
            of this Privacy Policy. If you do not agree, please do not use our
            website or app.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>1. Information We Collect</h2>
          <h3 className={classes.h3}>1.1. Personal Information</h3>
          <p>When you create an account, we may collect:</p>
          <ul>
            <li>
              <strong>Username:</strong> Your chosen username for account
              creation and community interactions.
            </li>
            <li>
              <strong>Email Address:</strong> Used for account registration,
              login, and account-related notifications.
            </li>
            <li>
              <strong>Password:</strong> Used to protect your account.
            </li>
          </ul>
          <h3 className={classes.h3}>1.2. Usage Data</h3>
          <p className={classes.p}>
            We may collect information about how you use our website, including:
          </p>
          <ul>
            <li>
              <strong>Interactions:</strong> Posts, likes, comments, and other
              community interactions.
            </li>
          </ul>
          <h3 className={classes.h3}>1.3. Cookies and Tracking Technologies</h3>
          <p className={classes.p}>
            We use cookies and similar technologies to improve your experience
            on our website, remember your preferences, and analyze website
            traffic.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>2. How We Use Your Information</h2>
          <p className={classes.p}>
            We use the information we collect for the following purposes:
          </p>
          <ul>
            <li>
              <strong>Account Management:</strong> To create and manage your
              account.
            </li>
            <li>
              <strong>Content Personalization:</strong> To recommend movies,
              series, ratings, and reviews based on your interests.
            </li>
            <li>
              <strong>Community Interaction:</strong> To enable you to post,
              comment, like, and interact with other users in the community.
            </li>
            <li>
              <strong>Communication:</strong> To send you updates, newsletters,
              and promotional content (you may opt out of these communications).
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>3. Information Sharing and Disclosure</h2>
          <p className={classes.p}>
            We respect your privacy and will not share, sell, or rent your
            personal information to third parties without your consent, except
            in the following cases:
          </p>
          <ul>
            <li>
              <strong>Legal Requirements:</strong> We may disclose information
              if required by law or in response to legal proceedings, such as a
              court order or subpoena.
            </li>
            <li>
              <strong>Protection of Rights:</strong> We may disclose information
              if necessary to protect the rights, property, or safety of
              our users, or others.
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>4. Your Choices and Rights</h2>
          <ul>
            <li>
              <strong>Data Deletion:</strong> You may request the deletion of
              your account and personal information by visiting{" "}
              <Link to="/delete-account">Delete Account Page</Link>
            </li>
          </ul>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>5. Security of Your Information</h2>
          <p className={classes.p}>
            We take appropriate technical and organizational measures to protect
            your information from unauthorized access, loss, misuse, or
            alteration. However, no data transmission over the internet is
            entirely secure. Please protect your account by choosing a strong
            password and keeping it confidential.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>6. Children’s Privacy</h2>
          <p className={classes.p}>
            Our website is not intended for children under the age of 13, and we
            do not knowingly collect information from children. If you believe
            we have collected information from a child, please contact us
            immediately, and we will take appropriate action to remove the
            information.
          </p>
        </section>
        <section className={classes.section}>
          <h2 className={classes.h2}>7. Changes to This Privacy Policy</h2>
          <p className={classes.p}>
            We may update this Privacy Policy periodically to reflect changes in
            our practices, legal requirements, or for other operational reasons.
            We will notify you of any significant changes by posting the new
            Privacy Policy on this page and updating the "Last Updated" date.
          </p>
        </section>

        {/* <section className={classes.section}>
          <h2 className={classes.h2}>8. Contact Us</h2>
          <p className={classes.p}>
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or your personal information, please contact us at:
          </p>
          <p className={classes.p}>
            Email: info@visiontrek.in
            <br></br>
            Address: Phase 8 B, E 195, Phase 8B, Industrial Area, Sector 74,
            Sahibzada Ajit Singh Nagar, Punjab 160055
          </p>
        </section> */}
      </div>
    </motion.div>
  );
};

export default PrivacyPolicy;
